import { Tooltip } from "antd";
import { formatPhoneNumber, rupeeSymbol } from "../../../../utils/appUtils";

export const categoryFilterOptions = [
    { key: "LAWYER", value: "LAWYER", label: "Advocate" },
    { key: "CUSTOMER", value: "CUSTOMER", label: "Customer" }
];

export const layerTabData = [
    { label: "Active Advocate", content: "ACTIVE", key: "1" },
    { label: "Hold Advocate", content: "HOLD", key: "2" },
    { label: "Rejected Advocate", content: "REJECTED", key: "3" },
];

export const customerTabData = [
    { label: "Active Customer", content: "ACTIVE", key: "1" },
    { label: "Hold Customer", content: "HOLD", key: "2" }
];

export const LAWYER_COLUMN_HEADER = () => [
    {
        title: "SNo",
        width: 50,
        align: "center",
        render: (_, detail, index) => index + 1
    },
    {
        title: "Advocate Name / Advocate ID",
        width: 200,
        render: (detail) => {
            const first = detail?.firstName || "";
            const middle = detail?.middleName || "";
            const last = detail?.lastName || "";
            const fullName = `${first} ${middle} ${last}`.trim();
            const isLastLong = last?.length > 10;
            const shortName = isLastLong
                ? `${first} ${middle} ${last?.slice(0, 3)}...`
                : fullName;
            return (
                <>
                    {isLastLong ? (
                        <Tooltip title={fullName}>
                            <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                        </Tooltip>
                    ) : (
                        <p style={{ padding: 0, margin: 0 }}>{shortName || detail?.lawyerName || "Nil"}</p>
                    )}
                    <small style={{ color: "gray" }}>{detail?.lawyerNo || "Nil"}</small>
                </>
            );
        }
    },
    {
        title: "Bar Council ID",
        width: 100,
        render: (detail) => detail?.barCouncilId ? detail?.barCouncilId : "Nil"
    },
    {
        title: "Contact Info",
        width: 200,
        render: (detail) => {
            return <>
                <p style={{ padding: 0, margin: 0 }}>{detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}</p>
                <small style={{ color: "gray" }}>{detail?.email || "Nil"}</small>
            </>
        }
    },
    {
        title: "Specialization",
        width: 180,
       render: (detail) => {
            const specs = detail?.specialization || [];
            const joinedSpecs = specs?.join(", ");
            const displayText =
                specs?.length > 2 ? `${specs?.slice(0, 2)?.join(", ")}...` : joinedSpecs;
            return (
                <Tooltip title={joinedSpecs}>
                    <span>{displayText || "Nil"}</span>
                </Tooltip>
            );
        },
    }
];

export const CUSTOMER_COLUMN_HEADER = () => [
    {
        title: "SNo",
        align: "center",
        render: (_, detail, index) => index + 1
    },
    {
        title: "Customer Name / Customer ID",
        render: (detail) => {
            const first = detail?.firstName || "";
            const middle = detail?.middleName || "";
            const last = detail?.lastName || "";
            const fullName = `${first} ${middle} ${last}`.trim();
            const isLastLong = last?.length > 10;
            const shortName = isLastLong
                ? `${first} ${middle} ${last?.slice(0, 3)}...`
                : fullName;
            return (
                <>
                    {isLastLong ? (
                        <Tooltip title={fullName}>
                            <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                        </Tooltip>
                    ) : (
                        <p style={{ padding: 0, margin: 0 }}>{shortName || "Nil"}</p>
                    )}
                    <small style={{ color: "gray" }}>{detail?.customerNo || "Nil"}</small>
                </>
            );
        }
    },
    {
        title: "Contact Info",
        render: (detail) => {
            return <>{detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}</>
        }
    },
    {
        title: "Balance Amount",
        render: (detail) => {
            const val = detail?.myBalance?.toLocaleString("en-IN");
            return <>{val ? <>{rupeeSymbol} {val}</> : "Nil"}</>
        }
    }
];

export const consultationChartDetails = [
    {
        key: "totalConsultation",
        label: "Total Cons.",
        color: "#84B0FF",
    },
    {
        key: "completeConsultation",
        label: "Completed Cons.",
        color: "#53EF8E",
    },
    {
        key: "upComingConsultation",
        label: "Upcoming Cons.",
        color: "#F3B56F",
    },
    {
        key: "cancelledConsultation",
        label: "Cancelled Cons.",
        color: "#ED6D73",
    },
    {
        key: "autoCancelledConsultation",
        label: "Auto Cancel Cons.",
        color: "#EC6E9A"
    }
];

export const complaintChartDetails = [
    {
        key: "totalPendingComplaints",
        label: "Pending Complaints",
        color: "#FFC75F"
    },
    {
        key: "totalCompletedComplaints",
        label: "Completed Complaints",
        color: "#FFA804"
    }
];
export const supportChartDetails = [
    {
        key: "totalPendingSupport",
        label: "Pending Support",
        color: "#7ED1D1",
    },
    {
        key: "totalCompletedSupport",
        label: "Completed Support",
        color: "#005D60",
    }
];

export const overviewAmountChartDetails = [
    { key: "totalConsultationAmount", label: "Cons Amt", color: "#4A90E2" },
    { key: "totalRevenue", label: "Revenue", color: "#48BB78" },
    { key: "totalConsultationGstAmount", label: "GST Amt", color: "#7E57C2" },
    { key: "totalPenaltyAmount", label: "Penalty", color: "#F6AD55" },
    { key: "totalRefundAmount", label: "Refund", color: "#38B2AC" },
    { key: "totalLawyerFee", label: "Advocate Fees", color: "#EC6E9A" },
];

export const caseRevenueChartDetails = [
    { key: "", label: "Family Law", color: "#1E85FF" },
    { key: "", label: "Criminal", color: "#7E57C2" },
    { key: "", label: "Property", color: "#F6AD55" },
    { key: "", label: "Civial", color: "#38B2AC" },
    { key: "", label: "Corporate", color: "#EC6E9A" }
];

export const lawyerChartDetails = [
    { key: "activeLawyers", label: "Active Advocates", color: "#00A5FF" },
    { key: "holdLawyers", label: "Hold Advocate", color: "#5FC7FF" },
    { key: "rejectedLawyers", label: "Rejected Advocates", color: "#A6E0FF" }
];

export const customerChartDetails = [
    { key: "activeCustomers", label: "Active Customer", color: "#00A5FF" },
    { key: "holdCustomers", label: "Hold Customer", color: "#5FC7FF" },
];

const MONTH_MAP = {
    JANUARY: "Jan",
    FEBRUARY: "Feb",
    MARCH: "Mar",
    APRIL: "Apr",
    MAY: "May",
    JUNE: "Jun",
    JULY: "Jul",
    AUGUST: "Aug",
    SEPTEMBER: "Sep",
    OCTOBER: "Oct",
    NOVEMBER: "Nov",
    DECEMBER: "Dec",
};

export const formatLabel = (key) => {
    if (MONTH_MAP[key]) {
        return MONTH_MAP[key];
    }
    return key;
};

const BAR_COLORS = [
    "#4D96FF",
    "#7E57C2",
    "#F6AD55",
    "#FF6B6B",
    "#38B2AC",
    "#EC6E9A",
];


export const buildBarChartInput = (obj) => {
    const entries = Object.entries(obj ?? {});
    return {
        configData: entries?.map(([key], index) => ({
            label: key,
            color: BAR_COLORS?.[index % BAR_COLORS?.length],
        })),
        data: entries?.map(([, value]) => value),
    };
};

export const isColorDark = (color) => {
  if (!color) return false;
  const hex = color.replace("#", "");
  const red = parseInt(hex.substring(0, 2), 16);
  const green = parseInt(hex.substring(2, 4), 16);
  const blue = parseInt(hex.substring(4, 6), 16);
  const brightness = (red * 299 + green * 587 + blue * 114) / 1000;
  return brightness < 128; 
};

